import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { useLanguage, LanguageLink } from '@hilma/netina2all';

import { getAssociations, useAppDispatch, useAssociations, useAssociationsLoading } from '../redux';
import { useI18n } from '../hooks';

const AssociationsSample: React.FC = () => {

	const dispatch = useAppDispatch();
	const loading = useAssociationsLoading();
	const associations = useAssociations();
	const language = useLanguage();
	const homePageText = useI18n(i18n => i18n.homePageText);
	const alts = useI18n(i18n => i18n.alts);

	useEffect(() => {
		if (loading) compose(dispatch, getAssociations)();
	}, []);

	return (
		<div id='associations-sample' >
			<big>{homePageText.sitemap.donateTo}</big>
			<div id='associations-sample-overflow'>
				<div id='associations-sample-container'>
					{associations &&
						associations.slice(0, 16).map((association, index) => {
							return (
								<div className='associations-sample-item' key={index} >
									<a href={association.website} target='_blank' rel='noreferrer'>
										<img src={association.imagePath} alt={alts.associationLogo} />
									</a>
								</div>
							)
						})}
				</div>
			</div>

			<p><LanguageLink to='/associations'> {homePageText.allOrgs} <KeyboardBackspaceIcon style={language === 'he' ? { marginRight: '5px' } : { marginLeft: '5px', transform: 'rotate(180deg)' }} /> </LanguageLink></p>
		</div>
	);
}

export default AssociationsSample;